import { all, put, takeEvery, select } from 'redux-saga/effects'
import { TDefaultSagas } from 'hootsuite/common/redux/interface'
import store from 'store'
import ProfileService from 'Service/AccallioCloud/Profile'
import {TenantInfoList} from '@antegma/accallio-cloud-profile-api'
import { AnyAction } from 'redux'
import { notification } from 'antd'
import Axios, {AxiosResponse} from 'axios'
import actions from './actions'

export function* SET_TENANT({ payload }: AnyAction) {
  const { id } = payload

  const { accessToken } = yield select((state: TDefaultSagas) => ({ accessToken: state.oidc.user?.access_token }))
  const options = {'headers': {'Authorization': `Bearer ${accessToken}`}}

  const loadTenantResponse: AxiosResponse<TenantInfoList> = yield ProfileService.currentUserApi.getTenants(options).catch((e) =>
    notification.error({
      message: 'Unable to load current tenant',
      description: e.message,
    })
  )

  const tenants = loadTenantResponse.data.items;

  try {
    if(tenants != undefined) {
      const foundCurrent = tenants.filter((availableTenant: any) => availableTenant.id === id)
      const current = foundCurrent.length ? foundCurrent[0] : tenants[0]
      const tenantData = {
        current,
        available: tenants.filter((t: any) => t.isUserTenantAdmin === true),
      }
  
      yield store.set('app.tenant', JSON.stringify(tenantData))
  
      yield put({
        type: 'tenant/SET_STATE',
        payload: tenantData,
      })
    }
  } catch (error) {
    console.log(error)
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SET_TENANT, SET_TENANT)])
}
